import { emptyArray } from 'ui-components/default-props/empty';
import { InventoryService } from '../../../../../../services/inventory-service';

export const shipmentItemInventoryStatus = {
  isAllocated: 'isAllocated',
  hasLowStock: 'hasLowStock',
  isAvailable: 'isAvailable',
  isUntracked: 'isUntracked',
  isUnknown: 'isUnknown',
};

const getHasAllocatedStock = (stockLevels, itemQuantity) => {
  const allocatedStockInfo = stockLevels.find((sl) => sl.type === InventoryService.StockLevelQuantityType.Allocated);
  const { quantity: allocatedQuantity } = allocatedStockInfo || {};
  return allocatedQuantity === itemQuantity;
};

const getAvailableStockQuantity = (stockLevels) => {
  const availableStockLevels = stockLevels.find((stock) => stock.type === InventoryService.StockLevelQuantityType.Available);
  return availableStockLevels?.quantity;
};

const getHasLowStock = (availableStockQuantity, itemQuantity) => {
  // 0 is a valid value for availableStockQuantity
  return Number.isFinite(availableStockQuantity) && availableStockQuantity < itemQuantity;
};

const getHasAvailableStock = (availableStockQuantity, itemQuantity) => {
  return availableStockQuantity && availableStockQuantity >= itemQuantity;
};

export const getItemInventoryStatus = ({ item, inventoryStockLevelsMap, shouldShowInventoryInfo }) => {
  // return early if we know we don't need to display any UI based on the inventory status
  if (!shouldShowInventoryInfo) {
    return shipmentItemInventoryStatus.isUnknown;
  }

  const { fulfillmentPlanItemId, quantity: itemQuantity } = item;
  const { isUntracked, stockLevels = emptyArray } = inventoryStockLevelsMap[fulfillmentPlanItemId] || {};

  if (isUntracked) {
    return shipmentItemInventoryStatus.isUntracked;
  }

  const isAllocated = getHasAllocatedStock(stockLevels, itemQuantity);
  if (isAllocated) {
    return shipmentItemInventoryStatus.isAllocated;
  }

  const availableStockQuantity = getAvailableStockQuantity(stockLevels);

  const hasLowStock = getHasLowStock(availableStockQuantity, itemQuantity);
  if (hasLowStock) {
    return shipmentItemInventoryStatus.hasLowStock;
  }

  const isAvailable = getHasAvailableStock(availableStockQuantity, itemQuantity);
  if (isAvailable) {
    return shipmentItemInventoryStatus.isAvailable;
  }

  return shipmentItemInventoryStatus.isUnknown;
};
